import React, { useState } from "react";
import "./faq.css"; // Assuming the CSS is in this file
import { FaPlus } from "react-icons/fa6";

const FAQSection = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ((prev) => (prev === index ? null : index));
  };

  const faqs = [
    {
      question: "What services/products do you offer?",
      answer:
        "We specialize in providing high-quality safety nets for various applications, ensuring durability and reliability.",
    },
    {
      question: "How can I place an order?",
      answer:
        "You can place an order through our website by selecting the desired product/service and completing the checkout process.",
    },
    {
      question: "Do you offer custom solutions?",
      answer:
        "Yes, we offer tailored solutions to meet your specific requirements. Please contact us for more details.",
    },
    {
      question: "What are your delivery timelines?",
      answer:
        "Delivery times vary based on the product and location. Typically, orders are delivered within 5-7 business days.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept all major payment methods, including credit/debit cards, online banking, and digital wallets.",
    },
    {
      question: "Do you provide installation services?",
      answer:
        "Yes, we offer professional installation services. Please inquire about availability in your area.",
    },
    {
      question: "What is your return/exchange policy?",
      answer:
        "We offer a hassle-free return/exchange policy within 14 days of purchase, subject to terms and conditions.",
    },
    {
      question: "Are your safety nets certified?",
      answer:
        "Yes, all our safety nets comply with industry standards and certifications for quality and safety.",
    },
    {
      question: "How can I contact customer support?",
      answer:
        "You can reach our customer support team via email, phone, or live chat on our website.",
    },
    {
      question: "Do you offer discounts for bulk orders?",
      answer:
        "Yes, we provide special discounts for bulk orders. Please contact our sales team for a custom quote.",
    },
  ];

  return (
    <div className="faq">
      <ul className="faq-list">
        {faqs.map((faq, index) => (
          <li
            key={index}
            data-aos="fade-up"
            data-aos-delay={100 * (index + 1)}
            className={`aos-init aos-animate ${
              activeFAQ === index ? "open" : ""
            }`}
          >
            <button
              className="faq-toggle"
              onClick={() => toggleFAQ(index)}
              aria-expanded={activeFAQ === index}
            >
              {faq.question}{" "}
              <FaPlus
                className={`fas fa-arrow-up ${
                  activeFAQ === index ? "rotate" : ""
                }`}
              />
            </button>
            <div id={`faq${index}`} className="collapse">
              {activeFAQ === index && <p>{faq.answer}</p>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQSection;
